export const getErrorMessage = (error: unknown, defaultMessage = "Unknown error"): string => {
  if (typeof error === "string") return error;
  if (Array.isArray(error)) return error.join(", ");
  if (error && typeof error === "object") {
    const problemDetails = error as {
      title?: string;
      errors?: Record<string, string[] | string>;
      message?: string;
    };

    if (problemDetails.errors && typeof problemDetails.errors === "object") {
      const firstKey = Object.keys(problemDetails.errors)[0];
      if (firstKey) {
        const firstValue = problemDetails.errors[firstKey];
        if (Array.isArray(firstValue) && firstValue.length > 0) {
          return String(firstValue[0]);
        } else if (typeof firstValue === "string") {
          return firstValue;
        }
      }
    }

    if (problemDetails.title) {
      return problemDetails.title;
    }

    if (problemDetails.message) {
      return String(problemDetails.message);
    }
  }

  return defaultMessage;
};

export const flattenItems = (items: unknown[]): unknown[] => {
  return items.flatMap((item) => {
    const i = item as { children?: unknown[] };
    return i.children ? i.children : [item];
  });
};

export function replaceOptimisticItem<T>(
  old: T[] | undefined,
  options: {
    matchOptimistic: (item: T) => boolean;
    replaceWith: T;
  }
): T[] {
  if (!old) {
    return [options.replaceWith];
  }

  let replaced = false;

  const next = old.map((item) => {
    if (!replaced && options.matchOptimistic(item)) {
      replaced = true;
      return options.replaceWith;
    }
    return item;
  });

  return replaced ? next : [...next, options.replaceWith];
}
